exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-6743e7a8] {\n  overflow: hidden;\n}\n", ""]);

// exports
